import { render, staticRenderFns } from "./TikTokSetup.vue?vue&type=template&id=8e2b1094"
import script from "./TikTokSetup.vue?vue&type=script&lang=js"
export * from "./TikTokSetup.vue?vue&type=script&lang=js"
import style0 from "./TikTokSetup.vue?vue&type=style&index=0&id=8e2b1094&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports